export default "__VITE_ASSET__B$QaIP3c__"